'use client';

import { ShieldCheck, X } from '@holistic/components/icons';

type WarrantySelectedBannerProps = {
  onRemove: () => void;
};

const WarrantySelectedBanner = ({ onRemove }: WarrantySelectedBannerProps) => (
  <div className="flex items-center gap-3.5 rounded-2xl border border-emerald-100 bg-emerald-50/60 p-4">
    <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
      <ShieldCheck className="size-4.5" />
    </span>

    <div className="min-w-0 flex-1">
      <p className="text-sm font-semibold text-emerald-900">
        Garanti kapsamında
      </p>
      <p className="text-xs text-emerald-700/80">
        Bu talep ücretsiz olarak işleme alınacak.
      </p>
    </div>

    <button
      type="button"
      onClick={onRemove}
      aria-label="Garantiyi kaldır"
      className="flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-full text-emerald-600 transition-colors hover:bg-emerald-100 hover:text-emerald-900"
    >
      <X className="size-4" />
    </button>
  </div>
);

export default WarrantySelectedBanner;
